import { render, staticRenderFns } from "./QCReportsHome.vue?vue&type=template&id=6162c99f&scoped=true&"
import script from "./QCReportsHome.vue?vue&type=script&lang=js&"
export * from "./QCReportsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162c99f",
  null
  
)

export default component.exports